import React from "react";
import SvgSpinner from "./svgspinner";
import { Link } from "react-router-dom";
import { useUserBatchContributions } from "./balances";
import { formatEther } from "viem";
import { CollectiveMintingStatus } from "./collectivemint";

export default function BrainTable({ dataLoading, ownedBrains }) {
  const { loading, totalPooledCredits } = useUserBatchContributions();

  if (dataLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <SvgSpinner />
      </div>
    );
  }

  const renderBrainNFTs = () => {
    if (ownedBrains.length === 0) {
      return (
        <div>
          <Link
            to="/acquire-brain"
            className="d-flex justify-content-between align-items-end my-4 table-link"
          >
            <div>
              <small className="font-mono text-uppercase d-block d-flex align-items-center">
                0 Brains owned. Acquire one {">"}
              </small>
            </div>
          </Link>
        </div>
      );
    }

    return ownedBrains.map((brain) => (
      <div key={`brain-${brain.tokenId}`}>
        <div className="d-flex justify-content-between align-items-center my-4">
          <Link
            to="/configure-metadata"
            className="d-flex align-items-center table-link"
            style={{ width: "25%" }}
          >
            <span className="input-left me-2">
              <img src={brain.metadata.imageUrl || "img/icon-b.png"} alt="" />
            </span>
            <span>
              Brain #{brain.tokenId} | {brain.metadata.name || "SET NAME"}
            </span>
          </Link>

          <Link
            to="/configure-metadata"
            className="table-link"
            style={{ width: "25%" }}
          >
            {brain.metadata.ticker ? `$${brain.metadata.ticker}` : "SET TICKER"}
          </Link>

          {brain.metadata.metadataUrl ? (
            <a
              href={brain.metadata.metadataUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="table-link"
              style={{ width: "25%" }}
            >
              {brain.metadata.metadataUrl}
            </a>
          ) : (
            <Link
              to="/configure-metadata"
              className="table-link"
              style={{ width: "25%" }}
            >
              SET METADATA URL
            </Link>
          )}

          <Link
            to={`https://etherscan.io/nft/${process.env.REACT_APP_BRAIN_ERC721_CA}/${brain.tokenId}`}
            className="text-end table-link"
          >
            <div className="font-mono muted text-uppercase small">
              Etherscan {">"}
            </div>
          </Link>
        </div>
        <hr className="my-0" />
      </div>
    ));
  };

  return (
    // TODO: fix once brain tokens ready
    // <div className="col-sm-12 col-md-6 mt-5 mt-xl-0 w-full">
    <>
      <div className="col-sm-12 mt-5 mt-xl-0 w-full">
        <h1 className="my-4 text-left">Your Pooled Credits</h1>
        <div className="box mx-auto mw-100 w-full">
          <div className="py-4 px-3 px-md-5">
            <div className="d-flex justify-content-between align-items-end my-4">
              <div>
                <CollectiveMintingStatus
                  creditsPooledIsLoading={loading}
                  totalPooledCredits={totalPooledCredits}
                />
              </div>
            </div>

            {/* <div className="mb-4 mt-4">
            <a
              href="burning-redeem.html"
              disabled
              className="button align-items-center d-flex justify-content-center"
            >
              <span>Brain Token Market</span>
            </a>
          </div> */}
          </div>
        </div>
      </div>

      <div className="col-sm-12 mt-5 mt-xl-0 w-full">
        <h1 className="my-4 text-left">Your Brains</h1>
        <div className="box mx-auto mw-100 w-full">
          <div className="py-4 px-3 px-md-5">
            <div className="brain-table-container">
              <div className="brain-table-scroll">{renderBrainNFTs()}</div>
            </div>
            {/* <div className="mb-4 mt-4">
            <a
              href="burning-redeem.html"
              disabled
              className="button align-items-center d-flex justify-content-center"
            >
              <span>Brain Token Market</span>
            </a>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

// const { pooledCreditsAreLoading, pooledCredits } = usePooledCredits();
